import React from "react";
import { useTranslation } from "react-i18next";
import BlogCard from "./BlogCard";

export default function BlogList({ blogs }) {
  const { t } = useTranslation();

  if (blogs.length === 0) {
    return <p>{t("noArticlesInCategory")}</p>;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {blogs.map((blog) => (
        <BlogCard key={blog.id} blog={blog} />
      ))}
    </div>
  );
}